//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { SocialNetwork } from '@models/SocialNetwork';
import { isDefined } from '@utils/filterPredicates';

import {
  FacebookWebLinks,
  InstagramWebLinks,
  TikTokWebLinks,
  YouTubeWebLinks,
} from 'app/constants/social-links';

const CREATORS_PATH = '/influencers/user/';
const INSTAGRAM_HASHTAG_PATH = '/instagram/hashtags/';

export const getUserHref = (
  shouldLinkExternal: boolean,
  socialNetwork: SocialNetwork,
  username: string | undefined,
) => {
  if (isDefined(username)) {
    if (shouldLinkExternal) {
      switch (socialNetwork) {
        case SocialNetwork.TikTok:
          return TikTokWebLinks.getUserLink(username);
        case SocialNetwork.Instagram:
          return InstagramWebLinks.getUserLink(username);
        case SocialNetwork.Facebook:
          return FacebookWebLinks.getUserLink(username);
        case SocialNetwork.YouTube:
          return YouTubeWebLinks.getUserLink(username);
        default:
          return undefined;
      }
    } else {
      switch (socialNetwork) {
        case SocialNetwork.TikTok:
        case SocialNetwork.Instagram:
        case SocialNetwork.YouTube:
          return `${CREATORS_PATH}${username}?network=${socialNetwork}`;
        case SocialNetwork.Facebook:
          return FacebookWebLinks.getUserLink(username);
        default:
          return undefined;
      }
    }
  }

  return undefined;
};

export const getHashtagHref = (
  shouldLinkExternal: boolean,
  socialNetwork: SocialNetwork,
  tag: string,
) => {
  if (shouldLinkExternal) {
    switch (socialNetwork) {
      case SocialNetwork.TikTok:
        return TikTokWebLinks.getHashtagLink(tag);
      case SocialNetwork.Instagram:
        return InstagramWebLinks.getHashtagLink(tag);
      case SocialNetwork.YouTube:
        return YouTubeWebLinks.getHashtagLink(tag);
      default:
        return undefined;
    }
  } else {
    switch (socialNetwork) {
      case SocialNetwork.TikTok:
        // internal links not available for TikTok so link external
        return TikTokWebLinks.getHashtagLink(tag);
      case SocialNetwork.YouTube:
        // internal links not available for YouTube so link external
        return YouTubeWebLinks.getHashtagLink(tag);
      case SocialNetwork.Instagram:
        return `${INSTAGRAM_HASHTAG_PATH}${tag}`;
      default:
        return undefined;
    }
  }
};

export const getLocationHref = (
  socialNetwork: SocialNetwork,
  location: string,
) => {
  switch (socialNetwork) {
    case SocialNetwork.Instagram:
      return InstagramWebLinks.getLocationLink(location);
    default:
      return undefined;
  }
};
